export default {
	inputAriaLablel: "Телефон",
	header: "Получите персональное предложение по автоматизации:",
	button: "Оставить заявку",
}
